// A full page load, kept in its own module so tests can stub it: jsdom can't
// navigate, and `window.location` can't be redefined.
export function fullPageLoad(href: string) {
  window.location.assign(href);
}
